import { useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { useAccess } from '@/access/useAccess'
import { roleLabel as roleLabelFor } from '@/access/sections'
import { logout } from '@/auth/logout'
import { AccountMenu, IconButton, Sidebar } from '@/ui'
import styles from './Layout.module.css'
import { useBadgeCounts } from './useBadgeCounts'
import { useVersion } from './useVersion'

/** App shell: sidebar (nav from sections, counts from queries) + main. */
export function Layout() {
  const { condoId, sections, membership, me, roleLabel, contexts } = useAccess()
  const counts = useBadgeCounts()
  const { data: version } = useVersion()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [drawer, setDrawer] = useState(false)

  const base = `/c/${condoId}`
  const items = sections.map((s) => ({
    id: s.id,
    label: s.label,
    icon: s.icon,
    badge: counts[s.id],
    active: [s.path, ...(s.extraPaths ?? [])].some((p) => pathname === base + p),
  }))

  return (
    <div className={styles.layout}>
      <div className={styles.topbar}>
        <IconButton
          icon="menu"
          size={24}
          aria-label={drawer ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={drawer}
          onClick={() => setDrawer((d) => !d)}
        />
        <span className={styles.topbarTitle}>Condi</span>
      </div>
      <Sidebar
        open={drawer}
        items={items}
        onSelect={(id) => {
          const section = sections.find((s) => s.id === id)
          if (section) navigate(base + section.path)
          setDrawer(false)
        }}
        footer={
          <AccountMenu
            name={me.user?.name ?? membership.condominium_name}
            subtitle={`${membership.condominium_name} · ${roleLabel}`}
            options={contexts.map((c) => ({
              id: String(c.condominium_id),
              label: c.condominium_name,
              meta: roleLabelFor(c.scopes, me.is_root),
              icon: 'key',
              active: c.condominium_id === condoId,
            }))}
            onPick={(id) => navigate(`/c/${id}`)}
            onSignOut={() => void logout()}
            footnote={version ? `Versão ${version.sha.slice(0, 7)}` : undefined}
          />
        }
      />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  )
}
